import React, { Fragment, useEffect, useState } from 'react';
import { Route, match, Switch } from 'react-router-dom';

import { DefaultButton, Icon, IconButton, Panel, PanelType, Spinner, SpinnerSize, Text, TextField } from 'office-ui-fabric-react';

import { PiArrowsClockwiseBold } from "react-icons/pi";

import { Loading } from "./Shared";

import { httpGet } from '../core';

import MarkdownPreview from '@uiw/react-markdown-preview';

import '@uiw/react-markdown-preview/markdown.css'; // Default styles

// import '@uiw/react-markdown-preview/themes/github.css'; // Optional theme



import './DocumentationPage.scss';



const processWikiData = (data: string) => {

  return data
    .replaceAll('\n<col ', '<col ')
    .replaceAll('\n</colgroup>', '</colgroup>')
    .replaceAll('../portal/public/extracted-images', '/extracted-images');

};




interface WsDocumentationSection {
  id:     string;
  parentId: string;
  level:  number;
  text:   string;
  anchor: string;
}




const getSectionLevel = (text: string) => {

  if (text.startsWith('##### ')) {
    return 4;

  } else if (text.startsWith('#### ')) {
    return 3;

  } else if (text.startsWith('### ')) {
    return 2;

  } else if (text.startsWith('## ')) {
    return 1;

  } else {
    return 0;
  }
};




const getSectionList = (data: string) => {

  const sectionList: WsDocumentationSection[] = [];

  const match = data.match(/^(#{1,5}\s.+)/gmi);

  if (match && Array.isArray(match)) {

    let bulletLevel = 0;
    let bulletCounter0 = 0;
    let bulletCounter1 = 0;
    let bulletCounter2 = 0;

    match.forEach((value, index) => {

      let parentId = '';

      const level = getSectionLevel(value);

      const id = `section-${index}`;

      if (level > 0) {
        
        const prevSection = sectionList.findLast((item) => item.level === (level - 1));

        if (prevSection) {
          parentId = prevSection.id;
        }
      }

      const text = value
        .replaceAll('##### ', '')
        .replaceAll('#### ', '')
        .replaceAll('### ', '')
        .replaceAll('## ', '')
        .replaceAll('# ', '')
        .trim();

      const anchor = value
        .replaceAll('##### ', '')
        .replaceAll('#### ', '')
        .replaceAll('### ', '')
        .replaceAll('## ', '')
        .replaceAll('# ', '')
        .replaceAll('&', '')
        .replaceAll('(', '')
        .replaceAll(')', '')
        .trim()
        .toLowerCase()
        .replaceAll(' ',  '-');



      if (bulletLevel === level) {

      } else if (bulletLevel < level) {

        bulletLevel = level;

        if (level === 0) {
          bulletCounter0 = 0;
        } else if (level === 1) {
          bulletCounter1 = 0;
        } else if (level === 2) {
          bulletCounter2 = 0;
        }

      } else if (bulletLevel > level) {
        bulletLevel = level;
      }

      if (level === 0) {
        bulletCounter0++;
      } else if (level === 1) {
        bulletCounter1++;
      } else if (level === 2) {
        bulletCounter2++;
      }

      const bulletAndText = `${getBulletCounter(bulletLevel, bulletCounter0, bulletCounter1, bulletCounter2)} ${text}`;



      sectionList.push({
        level,
        id,
        parentId,
        text: bulletAndText,
        anchor
      });
    });
  }

  return sectionList;
};




const getBulletCounter = (bulletLevel: number, bulletCounter0: number, bulletCounter1: number, bulletCounter2: number) => {

  if (bulletLevel === 1) {
    return `${bulletCounter0}.${bulletCounter1}.`;

  } else if (bulletLevel === 2) {
    return `${bulletCounter0}.${bulletCounter1}.${bulletCounter2}.`;

  } else {
    return `${bulletCounter0}.`;
  }
};




const rebuildInProgress = false; // process.env.NODE_ENV === 'production' ? true : false;




const getDataReady = (data: any) => {

  const dataString = `${data}`;

  const dataSplit = dataString.split('# Introduction');

  const dataReturn = dataSplit.length === 2 ? dataSplit[1] : '';

  if (dataReturn) {

    return `
# Version & Author

| Version | Author                    | Comments                |
|---------|---------------------------|-------------------------|
| 0.1     | Doug Wood & Maris Balodis | Initial Version         |
| 0.2     | Doug Wood & Maris Balodis | Added Bill of Materials |
|         |                           |                         |

# Contents

Content Table is available in Side Panel.

# Introduction

${dataReturn}
`;

  } else {
    return '';
  }
};



const WsDocumentationPage = (props: {}) => {

  const [ tocPanel, setTocPanel ] = useState<boolean>(true);

  const [ sectionList, setSectionList ] = useState<WsDocumentationSection[] | undefined>(undefined);

  const [ wikiData, setWikiData ] = useState<string>('');



  useEffect(() => {

    setTimeout(async () => {

      const data = await httpGet(`${process.env.REACT_APP_REDIRECT_URI}/v1/documentation.txt`, {}, 'text');

      const dataReady = getDataReady(data);

      setSectionList(getSectionList(dataReady));

      setWikiData(processWikiData(dataReady));

    }, 500);

  }, []);



  if (sectionList && wikiData) {

    return (
      <div className="ws-sales-solution ws-sales-solution-list ws-sales-documentation-page">

        <div className="ws-sales-admin-header">
          <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>
            {'Documentation (Last Updated: 11/08/2025 15:10)'}
          </Text>

          <DefaultButton
            className="ws-sales-documentation-page-toc-button"
            iconProps={{ iconName: 'CustomList' }}
            title="Table of Contents"
            ariaLabel="Table of Contents"
            onClick={() => {
              setTocPanel(true);
            }}
            text="Table of Contents"
          />
        </div>

        <hr />

        {/* {
          sectionList.map((wikiHeading, index) => {
            return (
              <Fragment key={`ws-wiki-heading-${index}`}>
                <a href={`#${wikiHeading.anchor}`}>{wikiHeading.text}</a>
                <br />
              </Fragment>
            );
          })
        } */}

        {
          rebuildInProgress
          ?
          <>
            <div style={{ textAlign: 'center', paddingTop: '100px' }}>
              <PiArrowsClockwiseBold className="ws-rebuild-in-progress" style={{ fontSize: '64px' }} />
              <br />
              <b>Rebuilding Content Table</b>
            </div>
          </>
          :
          <>
            <MarkdownPreview
              source={wikiData}
              wrapperElement={{
                "data-color-mode": "light"
              }}
            />
          </>
        }

        {
          tocPanel
          &&
          <>
            <Panel
              customWidth="500px"
              isBlocking={false}
              isOpen={true}
              onDismiss={() => {
                setTocPanel(false);
              }}
              type={PanelType.custom}
            >
              <h2 className="title is-4">Table of Contents</h2>

              <WsDocumentationSectionList
                sectionList={sectionList}
                parentId={''}
              />

              {/* <MarkdownPreview
                source={wikiContents}
                wrapperElement={{
                  "data-color-mode": "light"
                }}
              /> */}
            </Panel>
          </>
        }
      </div>
    );

  } else {
    return (
      <div style={{ textAlign: 'center', paddingTop: '100px' }}>
        <Loading />
      </div>
    ); 
  }
};




const WsDocumentationSectionList = (props: { sectionList: WsDocumentationSection[], parentId: string }) => {

  const [ expandedIds, setExpandedIds ] = useState<string[]>([]);

  const sectionList = props.sectionList.filter((item) => item.parentId === props.parentId);

  return (
    <>
      {
        sectionList.map((documentationSection, index) => {

          const sectionHasChildren = props.sectionList.filter((item) => item.parentId === documentationSection.id).length > 0;

          const sectionIsExpanded = expandedIds.includes(documentationSection.id);

          const paddingLeft = 5 + (documentationSection.level * 21);

          return (
            <Fragment key={`ws-section-${index}`}>
              {
                sectionHasChildren
                ?
                <>
                  <span
                    className="ws-documentation-section-button ws-documentation-section-button-has-children"
                    style={{ marginLeft: `${paddingLeft}px` }}
                    data-level={documentationSection.level}
                    onClick={() => {
                      let nextExpandedIds = [ ...expandedIds ];
                      if (sectionIsExpanded) {
                        nextExpandedIds = nextExpandedIds.filter((item) => item !== documentationSection.id);
                      } else {
                        nextExpandedIds.push(documentationSection.id);
                      }
                      setExpandedIds(nextExpandedIds);
                    }}
                  >
                    {
                      sectionIsExpanded
                      ?
                      <>
                        <Icon
                          iconName={'CollapseContentSingle'}
                          className="ws-documentation-section-collapsed"
                        />
                      </>
                      :
                      <>
                        <Icon
                          iconName={'ExploreContentSingle'}
                          className="ws-documentation-section-expanded"
                        />
                      </>
                    }
                  </span>
                </>
                :
                <>
                  <span
                    className="ws-documentation-section-button ws-documentation-section-button-no-children"
                    style={{ marginLeft: `${paddingLeft}px` }}
                  >
                    <Icon
                      iconName={'ExploreContentSingle'}
                      className="ws-documentation-section-expanded"
                    />
                  </span>
                </>
              }

              <a href={`#${documentationSection.anchor}`}>{documentationSection.text}</a>
              <br />

              {
                sectionHasChildren
                &&
                sectionIsExpanded
                &&
                <WsDocumentationSectionList
                  sectionList={props.sectionList}
                  parentId={documentationSection.id}
                />
              }
            </Fragment>
          );
        })
      }
    </>
  );
};




export {
  WsDocumentationPage
};
